import type { RouteContext, Commands, RedirectResult } from '@vaadin/router';
import { getCurrentUser } from './session';

export async function requireAuth(context: RouteContext, commands: Commands): Promise<RedirectResult | void> {
  if (getCurrentUser()) return;
  localStorage.setItem('postLoginRedirect', context.pathname || '/');
  return commands.redirect('/login');
}
